module.exports = __webpack_public_path__ + "static/media/gb-logo-wh-transparent-bg.9c6e6217.png";